import type { MenuProps } from "antd";
// 子菜单类型
type MenuItem = Required<MenuProps>["items"][number];
export const menuItems = [
    {
        authId: 'card_00001',
        key: '/card',
        icon: '',
        label: '元宇名片管理',
        children: [
            {
                authId: 'card_00002',
                key: '/legalmind-user',
                icon: '',
                label: '律师用户表',
            },
            {
                authId: 'card_00003',
                key: '/wechat-apply-list',
                icon: '',
                label: '企微申请试用列表',
            },

            {
                authId: 'card_00004',
                key: '/complaint-feedback',
                icon: '',
                label: '投诉与反馈',
            },
            {
                authId: 'card_00005',
                key: '/chat-record',
                icon: '',
                label: '聊天记录',
            },
            {
                authId: 'card_00006',
                key: '/card-audit',
                icon: '',
                label: '审核管理',
            },
            {
                authId: 'card_00008',
                key: '/yydh-user-manage',
                icon: '',
                label: '用户管理',
            },
            {
                authId: 'card_00007',
                key: '/chat-feedback',
                icon: '',
                label: '问答评价',
            },
            {
                authId: 'card_00009',
                key: '/agent-manage',
                icon: '',
                label: '智能体管理',
            },
        ],
    },
    {
        authId: 'rj_00001',
        key: '/renji',
        icon: '',
        label: '仁济医院',
        children: [
            {
                authId: 'rj_00002',
                key: '/complaint-management',
                icon: '',
                label: '反馈管理',
                children: []
            },
            {
                authId: 'rj_00003',
                key: '/additional-slot',
                icon: '',
                label: '加号管理',
            },
        ]
    },
    {
        authId: 'jiafatong_00001',
        key: '/jiafatong',
        icon: '',
        label: '嘉兴法务区',
        children: [
            {
                authId: 'jiafatong_00002',
                key: '/law-chat-record',
                icon: '',
                label: '在线咨询',
            },
            {
                authId: 'jiafatong_00003',
                key: '/ai-agent-setting',
                icon: '',
                label: '智能体设置',
            },
        ]
    },
    {
        authId: 'elawyer_00001',
        key: '/qudao',
        icon: '',
        label: 'e律师',
        children: [
            {
                authId: 'elawyer_00002',
                key: '/trial-record',
                icon: '',
                label: '申请试用记录',
                children: []
            },
            {
                authId: 'elawyer_00003',
                key: '/e-lawyer',
                icon: '',
                label: '用户表',
            }
        ]
    },

    {
        authId: 'firm_00001',
        key: '/law-firm',
        icon: '',
        label: '企业管理',
        children: [
            {
                authId: 'firm_00002',
                key: '/law-firm-config',
                icon: '',
                label: '智能体配置',
                children: []
            },
            {
                authId: 'firm_00003',
                key: '/ai-tweet',
                icon: '',
                label: '推文管理',
            }
        ]
    },

    {
        authId: 'sys_00001',
        key: '/system',
        icon: '',
        label: '系统管理',
        children: [
            {
                authId: 'sys_00002',
                key: '/org-management',
                icon: '',
                label: '组织管理',
            },
            {
                authId: 'sys_00003',
                key: '/account-management',
                icon: '',
                label: '账号管理',
            },
            {
                authId: 'sys_00004',
                key: '/role-management',
                icon: '',
                label: '角色管理',
            },
            {
                authId: 'sys_00005',
                key: '/super-admin-account',
                icon: '',
                label: '超管账号',
            },
        ],
    },
]

// 递归创建菜单项
function getItem(
    label: React.ReactNode,
    key: string,
    icon?: React.ReactNode,
    children?: MenuItem[],
): MenuItem {
    return {
        key,
        icon,
        children: !!children?.length ? children : undefined,
        label,
    } as MenuItem;
}
// 根据权限过滤
export const filterMenuAndCollectOpenKeys = (menuList: any[], permissions: string[]) => {
    const openKeys: string[] = []; // 收集所有有 children 的父级 key

    function traverse(menu: any[]) {
        return menu
            .map(item => {
                const hasPermission = !item.authId || permissions.includes(item.authId);

                // 递归处理子菜单
                const filteredChildren = !!item.children?.length
                    ? traverse(item.children)
                    : [];

                // 如果当前项有权限，或子项有权限，则保留
                if (hasPermission || !!filteredChildren?.length) {
                    const key = item.key;
                    const childrenWithAuth: any = !!filteredChildren.length ? filteredChildren : '';

                    // 如果有子菜单（children 存在且非空），则记录 key 到 openKeys
                    if (childrenWithAuth) {
                        !openKeys.includes(key) && openKeys.push(key);
                    }

                    return getItem(
                        item.label,
                        item.key,
                        item.icon,
                        childrenWithAuth
                    );
                }

                return null;
            })
            .filter(Boolean);
    }

    const filteredMenu = traverse(menuList);

    return {
        filteredMenu,
        openKeys // 去重可选：[...new Set(openKeys)]
    };
}

